import { render, staticRenderFns } from "./ImportTemplateModal.vue?vue&type=template&id=33995664&scoped=true"
import script from "./ImportTemplateModal.vue?vue&type=script&lang=js"
export * from "./ImportTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./ImportTemplateModal.vue?vue&type=style&index=0&id=33995664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33995664",
  null
  
)

export default component.exports